import { render, staticRenderFns } from "./kanban-viewer.vue?vue&type=template&id=4326520a&scoped=true&"
import script from "./kanban-viewer.vue?vue&type=script&lang=ts&"
export * from "./kanban-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./kanban-viewer.vue?vue&type=style&index=0&id=4326520a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4326520a",
  null
  
)

export default component.exports